import Typography from '@mui/material/Typography';


export default function PharmaDrugsSubText2() {
  
  return (
<>


<Typography variant="subtitle2"> 

All medications are listed alphabetically. For each drug, you may see one or more
entries—this reflects the existence of multiple clinical guidelines or annotations
from trusted sources such as CPIC, DPWG, FDA, or FDA-PGx. Clicking on a drug opens a dialog showing:

<ul style={{ paddingLeft: '20px' }}>

<li>
The gene responsible for processing the drug
</li>

<li>
Your genotype and resulting phenotype (enzyme activity)
</li>

<li>
Relevant guidance, including possible clinical implications, dosage recommendations, and classification of the recommendation
</li>

</ul>

Where multiple guidelines exist, each one is displayed as a separate entry to allow for full transparency.
If any column shows a dash (-), this means that no specific concern has been identified for your genetic profile, or that
additional research is needed before clear guidance can be provided.

<br /><br />
Please also check the <Typography component="span" fontWeight={600}> "Population"</Typography> 
column to see if a recommendation applies to your situation—some guidelines are only
valid for specific groups (e.g., pediatric patients). 
<br /><br />
For explanations of medical
terms and abbreviations, refer to the  <Typography component="span" fontWeight={600}> "Important Read"</Typography> tab  .

 </Typography>



</>

   )
}